var _path, _path2, _path3, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConstruir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 145.158,
    y: 434.337,
    style: {
      fill: "#F23466"
    },
    width: 125.253,
    height: 69.911
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0",
    style: {
      fill: "#F23466"
    },
    d: "M56.029,434.334h89.127v69.91H29.992c-5.575,0-10.092-4.519-10.092-10.092 v-49.726c0-5.574,4.519-10.092,10.092-10.092l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1",
    style: {
      fill: "#F23466"
    },
    d: "M385.576,504.245H270.412v-69.91h115.164c5.574,0,10.092,4.519,10.092,10.092 v49.726C395.669,499.727,391.151,504.245,385.576,504.245z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.158,
    y: 432.621,
    style: {
      fill: "#CD315B"
    },
    width: 125.253,
    height: 71.628
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_0_1_",
    style: {
      fill: "#F23466"
    },
    d: "M56.029,434.334h89.127v69.91H29.992c-5.575,0-10.092-4.519-10.092-10.092 v-49.726c0-5.574,4.519-10.092,10.092-10.092l0,0"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_1_1_",
    style: {
      fill: "#F23466"
    },
    d: "M385.576,504.245H270.412v-69.91h115.164 c5.574,0,10.092,4.519,10.092,10.092v49.726C395.669,499.727,391.151,504.245,385.576,504.245z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M385.576,434.334h-5.488v44.238c0,5.574-4.519,10.092-10.092,10.092 H254.833H129.576H19.899v5.488c0,5.574,4.519,10.092,10.092,10.092h115.164h125.256h115.164c5.574,0,10.092-4.519,10.092-10.092 v-49.726C395.669,438.853,391.151,434.334,385.576,434.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CD315B"
    },
    d: "M239.308,362.356h83.392c5.711,0,10.34,4.629,10.34,10.34v52.445c0,5.711-4.629,10.34-10.34,10.34 H207.784v-73.126H239.308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M322.701,362.356h-0.505v51.941c0,5.711-4.629,10.34-10.34,10.34H207.784 v10.845H322.7c5.711,0,10.34-4.629,10.34-10.34v-52.445C333.041,366.985,328.411,362.356,322.701,362.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9C5B5"
    },
    d: "M228.079,319.759l-67.45,24.778c-3.309,1.215-6.524-2-5.309-5.309l24.778-67.45l30.844-30.844 l47.981,47.981L228.079,319.759z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC433"
    },
    points: "440.951,106.886 228.079,319.759 213.271,286.585 180.097,271.777 392.97,58.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC433"
    },
    points: "440.951,106.886 228.079,319.759 213.271,286.585 180.097,271.777 392.97,58.905  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3E3E3"
    },
    points: "468.794,79.043 440.596,108.965 392.528,60.672 420.813,31.062  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3E3E3"
    },
    points: "468.794,79.043 440.514,105.61 392.533,57.63 420.813,31.062  "
  })), /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2",
    style: {
      fill: "#F23466"
    },
    d: "M486.122,61.715l-23.81,23.81l-47.981-47.981l23.81-23.81 c7.99-7.99,20.943-7.99,28.933,0l19.048,19.048C494.112,40.772,494.112,53.725,486.122,61.715z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGCleanerId_2_1_",
    style: {
      fill: "#F23466"
    },
    d: "M486.122,61.715l-23.81,23.81l-47.981-47.981l23.81-23.81 c7.99-7.99,20.943-7.99,28.933,0l19.048,19.048C494.112,40.772,494.112,53.725,486.122,61.715z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#342E30"
    },
    d: "M160.628,344.536l38.268-14.058l-29.519-29.519l-14.058,38.268 C154.105,342.536,157.32,345.751,160.628,344.536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M156.034,343.59c1.065,1.065,2.697,1.566,4.351,0.958l67.45-24.778 l201.936-201.936l10.935-10.935l21.361-21.361l6.481-6.481l17.328-17.328c7.99-7.99,7.99-20.943,0-28.933l-9.525-9.525 L156.034,343.59z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.67,426.579h-54.873v-62.155c0-4.283-3.472-7.755-7.755-7.755h-93.732c-4.283,0-7.755,3.472-7.755,7.755 s3.472,7.755,7.755,7.755h85.977v54.4h-54.872H215.54v-62.155c0-4.283-3.472-7.755-7.755-7.755s-7.755,3.472-7.755,7.755v62.155 h-54.873H90.283v-9.738c0-4.283-3.472-7.755-7.755-7.755c-4.283,0-7.755,3.472-7.755,7.755v9.738H56.029 c-4.283,0-7.755,3.472-7.755,7.755s3.472,7.755,7.755,7.755h26.498H137.4v54.4H27.654v-54.4h2.338c4.283,0,7.755-3.472,7.755-7.755 s-3.472-7.755-7.755-7.755H19.899c-4.283,0-7.755,3.472-7.755,7.755v69.91c0,4.283,3.472,7.755,7.755,7.755h125.256h125.257h125.256 c4.283,0,7.755-3.472,7.755-7.755v-69.91C403.425,430.051,399.953,426.579,395.67,426.579z M152.91,442.09h54.873h54.873v54.4 H152.91V442.09z M387.914,496.489H278.168v-54.4h54.872h54.873v54.4H387.914z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.528,388.519c4.283,0,7.755-3.472,7.755-7.755v-8.585h43.858c4.283,0,7.755-3.472,7.755-7.755s-3.472-7.755-7.755-7.755 H82.528c-4.283,0-7.755,3.472-7.755,7.755v16.34C74.772,385.047,78.245,388.519,82.528,388.519z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M491.606,27.298L472.558,8.25c-11-11-28.9-11.001-39.9,0l-23.81,23.81l-21.361,21.361L174.614,266.294 c-0.018,0.018-0.032,0.038-0.05,0.056c-0.197,0.202-0.387,0.412-0.563,0.636c-0.006,0.008-0.014,0.017-0.021,0.025 c-0.184,0.237-0.355,0.485-0.513,0.746c-0.028,0.046-0.05,0.093-0.077,0.14c-0.116,0.2-0.223,0.404-0.323,0.617 c-0.043,0.094-0.082,0.189-0.121,0.285c-0.042,0.102-0.092,0.201-0.13,0.306l-27.86,75.842c-1.042,2.836-0.341,6.02,1.796,8.158 c1.481,1.481,3.463,2.272,5.486,2.272c0.897,0,1.801-0.155,2.672-0.476l75.842-27.86c0.047-0.018,0.089-0.039,0.135-0.058 c0.126-0.049,0.25-0.103,0.373-0.159c0.117-0.053,0.233-0.104,0.345-0.162c0.107-0.054,0.21-0.114,0.313-0.173 c0.124-0.07,0.247-0.142,0.366-0.218c0.086-0.055,0.169-0.115,0.252-0.174c0.128-0.09,0.255-0.181,0.377-0.278 c0.072-0.058,0.143-0.12,0.213-0.181c0.124-0.107,0.245-0.214,0.362-0.327c0.024-0.023,0.05-0.042,0.073-0.066l212.871-212.872 l21.361-21.361l23.81-23.81l0,0C502.607,56.198,502.606,38.299,491.606,27.298z M392.97,69.873L405.995,82.9 c-0.023,0.022-0.048,0.04-0.07,0.063L211.56,277.328l-18.008-8.038L392.97,69.873z M200.874,321.49l-22.509-22.509l6.149-16.74 l22.883,10.214l10.215,22.884L200.874,321.49z M172.473,315.024l12.36,12.36l-19.536,7.176L172.473,315.024z M230.567,306.304 l-8.039-18.009L416.893,93.93c0.023-0.023,0.041-0.048,0.063-0.07l13.027,13.027L230.567,306.304z M440.951,95.919l-18.506-18.507 l-18.506-18.507l10.393-10.394l37.013,37.013L440.951,95.919z M480.639,56.232l-18.326,18.326l-37.013-37.013l18.326-18.326 c4.953-4.953,13.012-4.953,17.965,0l19.048,19.048C485.592,43.219,485.592,51.279,480.639,56.232z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConstruir);
export default __webpack_public_path__ + "static/media/construir.71029a6c4ac9ab4330a6a9cf56bbf6ef.svg";
export { ForwardRef as ReactComponent };